import React, { FC } from "react";
import useTheme from "evcharging/hooks/useTheme";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import { Plan } from "services/quotes/types";
import useI18n from "evcharging/hooks/useI18n";

interface RatesSelectPlanButtonProps {
  plan: Plan;
  onSelect: (plan: Plan) => void;
  buttonText?: string;
}

const RatesSelectPlanButton: FC<RatesSelectPlanButtonProps> = (props) => {
  const { t } = useI18n();

  const { plan, onSelect, buttonText = t('rates.select-plan') } = props;
  const theme = useTheme();
  const classes = createStyles(theme);

  return (
    <button
      className={classes.buttonGrayBorder}
      onClick={() => onSelect(plan)}
    >
      {buttonText}
    </button>
  );
};

const createStyles = (theme: Theme) => (
  {
    buttonGrayBorder: css({
      cursor: 'pointer',
      color: "#000",
      boxShadow: "none",
      border: "1px solid #D3D5DC !important",
      borderRadius: 6,
      backgroundColor: "transparent",
      padding: 10,
      fontSize: "16px",
      fontFamily: "Mulish,sans-serif !important",
      fontWeight: 700,
      lineHeight: 1.75,
      "&:hover": {
        backgroundColor: theme.colors.accent,
        border: `1px solid ${theme.colors.accent} !important`
      }
    })
  });

export default RatesSelectPlanButton;
